import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

import { AttributeTagProps } from './types';

export default makeStyles((theme: typeof muiTheme) => ({
    root: {
        minWidth: '29px',
        width: 'fit-content' as const
    },
    text: {
        display: 'flex' as const,
        justifyContent: 'center' as const,
        padding: '.2rem .25rem',
        fontSize: '12px',
        backgroundColor: (props: AttributeTagProps) => props.backgroundColor || 'inherit' as const,
        color: theme?.app?.applicationColors.enumColors.grey || '#666666',
        border: (props: AttributeTagProps) => `1px solid ${props.borderColor ||
        theme?.app?.applicationColors.success ||
        '#A5D673'}`,
        borderRadius: '3px'
    }
}));